import { useState } from "react";
import { COUNTRIES } from "@/lib/countries";

const DIAL = {
  AR: "54", AU: "61", BR: "55", CA: "1", CH: "41", CL: "56", CN: "86", CO: "57", CZ: "420", DE: "49",
  DK: "45", EG: "20", ES: "34", FR: "33", GB: "44", HK: "852", ID: "62", IE: "353", IL: "972", IN: "91",
  IT: "39", JP: "81", KE: "254", KR: "82", MX: "52", MY: "60", NG: "234", NL: "31", NO: "47", NZ: "64",
  PH: "63", PK: "92", PL: "48", PT: "351", RO: "40", SA: "966", SE: "46", SG: "65", TH: "66", TR: "90",
  TW: "886", UA: "380", AE: "971", US: "1", VN: "84", ZA: "27",
};
const OPTIONS = COUNTRIES.filter((c) => DIAL[c.code]);

// Splits "+919876543210" into { code: "IN", number: "9876543210" }, preferring the hint country.
function split(value, hint) {
  const digits = (value || "").replace(/[^\d]/g, "");
  if (!value?.startsWith("+")) return { code: DIAL[hint] ? hint : "US", number: digits };
  const matches = OPTIONS.filter((c) => digits.startsWith(DIAL[c.code])).sort((a, b) => DIAL[b.code].length - DIAL[a.code].length);
  const pick = matches.find((c) => c.code === hint) || matches[0];
  return pick ? { code: pick.code, number: digits.slice(DIAL[pick.code].length) } : { code: hint || "US", number: digits };
}

export const isValidPhone = (v) => !v || /^\+\d{7,15}$/.test(v);

export default function PhoneInput({ value, onChange, defaultCountry, testid = "phone" }) {
  const [code, setCode] = useState(() => split(value, defaultCountry).code);
  const number = split(value, code).number;
  const emit = (c, n) => onChange(n ? `+${DIAL[c]}${n.replace(/[^\d]/g, "").replace(/^0+/, "")}` : "");
  const field = "px-3 py-2 rounded-lg bg-[color:var(--bg-elev)] border border-[color:var(--bd-sub)] focus:border-indigo-500 outline-none";
  return (
    <div className="flex gap-2">
      <select data-testid={`${testid}-country`} value={code} onChange={(e) => { setCode(e.target.value); emit(e.target.value, number); }} className={`${field} w-40 shrink-0`}>
        {OPTIONS.map((c) => <option key={c.code} value={c.code}>+{DIAL[c.code]} {c.name}</option>)}
      </select>
      <input data-testid={testid} value={number} inputMode="tel" placeholder="Phone number" onChange={(e) => emit(code, e.target.value)} className={`${field} flex-1 min-w-0`} />
    </div>
  );
}
